var map = {
	"./a1.glb": 85,
	"./alchemist-helmet-1.glb": 86,
	"./alchemist-robes-1.glb": 87,
	"./alchemist-staff-1.glb": 88,
	"./alchemist-wings-1.glb": 89,
	"./apple-1.glb": 90,
	"./axe-1.glb": 91,
	"./axe-2.glb": 92,
	"./axe-3.glb": 93,
	"./banner-1.glb": 94,
	"./black-hat.glb": 95,
	"./bomb-1.glb": 96,
	"./cape-1.glb": 97,
	"./fish-1.glb": 98,
	"./fishing-rod-1.glb": 99,
	"./hammer-1.glb": 100,
	"./helmet-1.glb": 101,
	"./horse-head-helmet-1.glb": 102,
	"./hr1-helmet.glb": 103,
	"./iron-ore-1.glb": 104,
	"./key-1.glb": 105,
	"./log-1.glb": 106,
	"./pauldron-1.glb": 107,
	"./pauldron-2.glb": 108,
	"./pickaxe-1.glb": 109,
	"./placeholder-1.glb": 110,
	"./platebody-1.glb": 111,
	"./pole-1.glb": 112,
	"./shield-1.glb": 113,
	"./shield-2.glb": 114,
	"./shield-3.glb": 115,
	"./shield-4.glb": 116,
	"./shield-5.glb": 117,
	"./shield-book-1.glb": 118,
	"./shield.glb": 119,
	"./sword-2.glb": 120,
	"./sword-2b.glb": 121,
	"./sword-3.glb": 122,
	"./sword-4.glb": 123,
	"./torch-1.glb": 124,
	"./trident-1.glb": 125,
	"./vase-1.glb": 126,
	"./witch-staff-1.glb": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;